import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    // padding: "10px",
    // borderRadius: "20px"
  },
  infoItem: props => ({
    display: "flex",
    flexDirection: props.flexDirection,
    marginBottom: "4px",
  }),
  headerText: {
    color: theme.palette.primaryGrey,
    maxWidth: "200px",
    minWidth: "150px"
  },
  rowHeaderText: {
    color: theme.palette.primaryGrey,
  }
}));
